import styled from 'styled-components';

export const MobileImage = styled.img`
  width: 148px;
  height: 148px;
  object-fit: cover;
`;
